export const API_ENDPOINTS = {
  //ADMIN

  ADMIN_LOGIN: "/admin/login",
  USER_DELETE: "/delete",
  ADMIN_DETAIL: "/admin/profile",
  ADMIN_SAVE: "/admin/save-profile",
  VALIDATE_TOKEN: "/validate-token",
  ADMIN_UPDATE_PASSWORD: "/admin/update-password",

  // FILE
  FILE_LIST: "/file/list",
  FILE_SAVE: "/file/save",
  FILE_DELETE: "/file/remove",
  FILE_UPLOAD: "/file/upload",
  FILE_DOWNLOAD: "/file/download",
  FILE_PREVIEW: "/file/preview",
  FILE_REMOVE: "/file/remove",

  // PAGES
  PAGE_SAVE: "/pages/save",
  PAGE_DETAIL: "/pages/details",

  //SERVICE LIST
  SERVICE_LIST: "/service/list",
  SERVICE_SAVE: "/service/save",
  SERVICE_DELETE: "/service/delete",

  //PROJECT LIST
  PROJECT_LIST: "/project/list",
  PROJECT_SAVE: "/project/save",
  PROJECT_DELETE: "/project/delete",
  
  //ALL PAGES
  ALL_PAGE_SAVE: "/pages/save",
  ALL_PAGE_DETAIL: "/pages/detail",


   //ALL PAGES
  PAGE_BANNER_SAVE: "/pagebanner/save",
  PAGE_BANNER_DETAIL: "/pagebanner/detail",

  
  //TEAM MEMBERS LIST
  MEMBER_LIST: "/member/list",
  MEMBER_SAVE: "/member/save",
  MEMBER_DELETE: "/member/delete",

  //HISTORY JOURNEY LIST
  JOURNEY_LIST: "/journey/list",
  JOURNEY_SAVE: "/journey/save",
  JOURNEY_DELETE: "/journey/delete",

  //HOMEPAGE
  HOMEPAGE_DETAIL: "/homepage/detail",
  HOMEPAGE_SAVE: "/homepage/save",


  // HOMEPAGE BEFORE LOGIN
  HOMEPAGE_BEFORE_DETAIL: "/prelogin/detail",
  HOMEPAGE_BEFORE_SAVE: "/prelogin/save",

  
  // ABOUT PAGE
  ABOUT_SAVE: "/about/save",
  ABOUT_DETAIL: "/about/detail",



  //CONTACT
  CONTACT_LIST: "/contact/list",

  // MENU_FOOD_LIST: '/menu/item/list',
  // MENU_FOOD_CUSTOMIZATION_LIST: '/menu/item/customizations/list',
  // MENU_FOOD_SAVE: '/menu/item/save',
  // MENU_FOOD_DELETE: '/menu/item/delete',
  // MENU_FOOD_DETAIL: '/menu/item/detail',

  SETTING_LIST: "/restaurant-setting/list",
  SETTING_SAVE: "/restaurant-setting/save",
  SETTING_DELETE: "/restaurant-setting/delete",

  USER_LIST: "/user/list",
  USER_DETAIL: "/user/detail",

  USER_SAVE: "/admin/update-profile",
  USER_UPDATE_PASSWORD: "/admin/update-password",
  USER_UPDATE_RESTAURANT_PROFILE: "/admin/update-restaurant-profile",

  //consultation
  CONSULTATION_LIST: "/consultation-booking/list",
  CONSULTATION_UPDATE: "/consultation-booking/update",
  CONSULTATION_DELETE: "/consultation-booking/delete",
  CONSULTATION_DETAIL: "/consultation-booking/detail",

  //document
  DOCUMENT_LIST: "/document/list",
  DOCUMENT_DETAIL: "/document/detail",
  DOCUMENT_UPDATE: "/document/update-status",

  //account
  ACCOUNTANT_LIST: "/accountant/list",
  ACCOUNTANT_DETAIL: "/accountant/detail",
  ACCOUNTANT_CREATE: "/accountant/create",
  ACCOUNTANT_UPDATE: "/accountant/update",
  ACCOUNTANT_DELETE: "/accountant/delete",

  //dynamic form
  DYNAMIC_FORM_LIST: "/dynamic-form/fields/list",
  DYNAMIC_FORM_DETAIL: "/dynamic-form/fields/detail",
  DYNAMIC_FORM_CREATE: "/dynamic-form/fields/create",
  DYNAMIC_FORM_DELETE: "/dynamic-form/fields/delete",

  //web info
  WEB_INFO_LIST: "/web-info/list",
  WEB_INFO_SAVE: "/web-info/create",
  WEB_INFO_DETAIL: "/web-info/detail",

  //sub admins
  SUB_ADMINS_LIST: "/admin/sub-admin/list",
  SUB_ADMINS_CREATE: "/admin/sub-admin/save",
  SUB_ADMINS_UPDATE: "/admin/sub-admin/update",
  SUB_ADMINS_DETAILS: "/admin/sub-admin/details",

  //notification
  NOTIFICATION_LIST: "/notification/list",
  NOTIFICATION_MARK_ALL_READ: "/notification/mark-all-read",

  // dashboard
  DASHBOARD_STATS: "/dashboard/stats",

  // Filling management list
  FILLING_MANAGEMENT_LIST: "/filling-management/list",
  FILLING_MANAGEMENT_DETAILS: "/filling-management/details",

  SEND_REMINDER: "/filling-management/send-reminder",
  FILLING_MANAGEMENT_UPDATE_APPROVAL_STATUS: "/filling-management/update-approval-status",


  TRANSACTION_LIST: "/transaction/list",

};
